var React = require('react');

function IcAwsOpsworksResources (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M37.006,9.695L20.423,0.113c-0.261-0.151-0.584-0.151-0.846,0L2.993,9.695c-0.261,0.151-0.422,0.43-0.422,0.732\n\tv19.146c0,0.302,0.161,0.581,0.422,0.733l16.583,9.581C19.707,39.962,19.854,40,20,40s0.292-0.038,0.423-0.113l16.584-9.581\n\tc0.262-0.151,0.423-0.43,0.423-0.733V10.427C37.429,10.125,37.268,9.846,37.006,9.695z M20,1.822l15.237,8.804L20,19.429\n\tL4.763,10.626L20,1.822z M4.262,12.289l14.892,8.605v16.794L4.262,29.085V12.289z M20.845,37.689V20.894l14.892-8.605v16.796\n\tL20.845,37.689z"}));
}

IcAwsOpsworksResources.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsOpsworksResources;

IcAwsOpsworksResources.default = IcAwsOpsworksResources;
